import { AppointmentDto } from "../calendar/interfaces/appointment_dto";

export function formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours() + 1).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
  
    return `${year}-${month}-${day}_${hours}-${minutes}`;
  }

export function calculateTotalTime(appointments: AppointmentDto[]): string {
    if (!appointments || appointments.length === 0) return '0h 0min';
    
    let totalMinutes = 0;
    
    appointments.forEach(appointment => {
      if (appointment.StartTime && appointment.EndTime) {
        const start = new Date(appointment.StartTime);
        const end = new Date(appointment.EndTime);
        const diffMs = end.getTime() - start.getTime();
        const diffMinutes = Math.floor(diffMs / 60000);
        totalMinutes += diffMinutes;
      }
    });
    
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    
    return `${hours}h ${minutes}min`;
  }